<template>
    <div
        class="form-group select"
        :class="{ 'form-group-floating-label': $slots.default }"
    >
        <select
            v-model="localValue"
            :name="name"
            :required="required"
            class="form-input"
            :tabindex="tabindex"
            :disabled="disabled"
        >
            <option
                v-if="placeholder"
                value=""
                :disabled="required"
            >
                {{ placeholder }}
            </option>

            <option
                v-for="(option, val) in options"
                :value="val"
            >
                {{ option }}
            </option>
        </select>

        <label
            v-if="$slots.default"
            class="floating-label"
        >
            <slot />
        </label>

        <select-arrow />
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: [String, Number],
                required: false,
                default: null,
            },
            options: {
                type: [Object, Array],
                required: true,
            },
            name: {
                type: String,
                default: null,
            },
            placeholder: {
                required: false,
                type: String,
                default: null,
            },
            required: {
                required: false,
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: null,
            },
            tabindex: {
                type: Number,
                default: null,
            },
            optOutSorting: {
                type: Boolean,
                default: false,
                required: false,
            },
        },
        data() {
            return {
                localValue: this.value,
            };
        },
        computed: {
            defaultOption() {
                // Set default to first option value to mimic a native select
                return (this.placeholder !== null) ? '' : Object.keys(this.options)[0];
            },
        },
        watch: {
            localValue(newValue) {
                if (newValue === this.value) {
                    return;
                }

                if (newValue === null || newValue === undefined) {
                    this.$emit('input', this.defaultOption);
                    return;
                }

                this.$emit('input', newValue);
            },
            value(newValue) {
                if (newValue === this.localValue) {
                    return;
                }

                this.localValue = newValue;
            },
        },
        created() {
            if (this.localValue === '') {
                this.localValue = this.defaultOption;
            }

            if (this.optOutSorting) return;

            const selector = 'select[name="' + this.name + '"]';

            setTimeout(() => {
                const selectElement = document.querySelector(selector);

                if (! selectElement) return;

                [...selectElement.children]
                    .sort((a, b) => {
                        if (this.isOptionLabel(a)) return -1;
                        if (this.isOptionLabel(b)) return 1;
                        if (this.isOptionEmpty(a)) return -1;
                        if (this.isOptionEmpty(b)) return 1;

                        return a.innerText.toLocaleLowerCase() > b.innerText.toLocaleLowerCase() ? 1 : -1;
                    })
                    .forEach(node => selectElement.appendChild(node));
            });
        },
        methods: {
            isOptionEmpty(optionElement) {
                return  optionElement.value === '';
            },
            isOptionLabel(optionElement) {
                return optionElement.disabled && this.isOptionEmpty(optionElement);
            },
        },
    };
</script>
